export function initialize(appInstance) {
  const config = appInstance.resolveRegistration('config:environment');
  const service = appInstance.lookup('service:features');
  if (!config.featureFlags) {
    return;
  }
  if (Object.keys(config.featureFlags).length > 0) {
    service.setup(config.featureFlags, config.featureFlagTypes);
  }
}
export default {
  initialize
};